import api from "../utils/api";
import getSiteInfo from "../utils/getSiteInfo";

export const memberCreate = async body => {
  // orgId                           //组织id  //api/site/En 返回的CountryleadsLang
  // country                       // region Id  //api/site 返回的CountryOrg，global站点则是用户自己选的国家id
  // preferredLanguage    //api/site 返回的CountryleadsLang
  const siteInfo = await getSiteInfo();
  let bodys = {
    orgId: siteInfo.organization,
    country: siteInfo.country,
    preferredLanguage: siteInfo.preferredLanguage,
    ...body
  };
  // contractId
  // surname                      //last Name
  // firstName                    //First Name
  // emailAddress
  // isEmailOptout             //0 未订阅  1订阅
  // membership              //membershipcode
  /*let level02 = {
    contractId: "",
    surname: "",
    firstName: "",
    emailAddress: "",
    isEmailOptout: "",
    membership: ""
  };*/
  // contractId
  // surname                     //last Name
  // firstName                   //First Name
  // province
  // city
  // postcode
  // address1
  // address2
  // emailAddress
  // hasPaidDeposit            //固定传1
  // isEmailOptout             //0 未订阅  1订阅
  // mobileContryCode     //电话号码国家号
  // mobile                        //电话号码
  // interestedModel        //SPU属性的model的值
  // exteriorColor             //Color
  // engine                       //engine
  // isFinanceServiceRequest       //是否FinanceService
  // membership             //membershipcode
  /*let level3 = {
    contractId: "",
    surname: "",
    firstName: "",
    province: "",
    city: "",
    postcode: "",
    address1: "",
    address2: "",
    emailAddress: "",
    hasPaidDeposit: "1",
    isEmailOptout: "",
    mobileContryCode: "",
    mobile: "",
    interestedModel: "",
    exteriorColor: "",
    engine: "",
    isFinanceServiceRequest: "",
    membership: ""
  };*/
  const res = await api.leads.member.create(null, {
    ...bodys
  });
  console.dir(res);
};
